import { render, staticRenderFns } from "./Hora.vue?vue&type=template&id=a6c746e6&scoped=true&"
import script from "./Hora.vue?vue&type=script&lang=js&"
export * from "./Hora.vue?vue&type=script&lang=js&"
import style0 from "./Hora.vue?vue&type=style&index=0&id=a6c746e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c746e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
